"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkTokenPayloadSchema = exports.LinkCreatePayloadSchema = exports.LinkObjectSchema = exports.LinkActionSchema = void 0;
const zod_1 = require("zod");
const thread_1 = require("../thread");
// Object
exports.LinkActionSchema = zod_1.z
    .object({
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    schema: zod_1.z.record(zod_1.z.string(), zod_1.z.any()),
})
    .openapi('LinkAction');
exports.LinkObjectSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    object: zod_1.z.literal('link'),
    url: zod_1.z.string(),
    expires_at: zod_1.z.date().openapi({ type: 'string', format: 'date-time' }),
    created_at: zod_1.z.date().openapi({ type: 'string', format: 'date-time' }),
})
    .openapi('LinkObject');
// Create
exports.LinkCreatePayloadSchema = zod_1.z
    .object({
    account: zod_1.z.string({ description: 'Account ID' }).optional(),
    config: thread_1.ThreadCreatePayloadSchema,
})
    .openapi('LinkCreatePayload');
exports.LinkTokenPayloadSchema = zod_1.z.object({
    account: zod_1.z.string({ description: 'Account ID' }).nullable(),
    config: thread_1.ThreadCreatePayloadSchema,
});
//# sourceMappingURL=linkSchema.js.map